import React from "react";
import { cn } from "@/utils/helpers";
import SvgIcon, { SvgIconProps } from "./SvgIcon";
import styles from "../Svg.module.css";

export default function SvgIconLink({
	className,
	...props
} : SvgIconProps) {
	return (
		<SvgIcon
			className={cn(styles.SvgIconLink, className)}
			{...props}
		>
			<path d="M58.3327 20.9632C67.9333 11.6055 83.3013 11.6794 92.8103 21.1858C102.394 30.7696 102.398 46.3112 92.8161 55.8958L72.9304 75.7815C64.4253 84.2862 51.2311 85.238 41.6696 78.6478C32.0685 88.0088 16.6969 87.9306 7.18722 78.4212C-2.39498 68.8365 -2.3965 53.3008 7.18722 43.7171L27.072 23.8314C35.5779 15.3276 48.7721 14.3724 58.3327 20.9632ZM51.8464 27.4446C45.9298 24.2463 38.3845 25.1459 33.3845 30.1439L13.4987 50.0286C7.40113 56.1262 7.40278 66.0101 13.4987 72.1087C19.5218 78.1318 29.2417 78.2113 35.3562 72.3372C28.7602 62.7758 29.7132 49.5791 38.2204 41.0716L51.8464 27.4446ZM86.4978 27.4974C80.4751 21.4775 70.7589 21.4031 64.6452 27.2747C71.2387 36.8361 70.2872 50.0345 61.7829 58.5413L48.1569 72.1663C54.0743 75.3643 61.6199 74.468 66.6189 69.469L86.5046 49.5843C92.6008 43.4857 92.5954 33.595 86.4978 27.4974ZM44.5329 47.3831C39.5294 52.3866 38.6332 59.9389 41.8405 65.8577L55.4704 52.2298C60.471 47.2272 61.3651 39.6741 58.1599 33.7552L44.5329 47.3831Z" />
		</SvgIcon>
	)
}
